module.exports = __webpack_public_path__ + "media/audio39.951a83b5.mp3";